import { Intl } from "../enums/Intl";

export const supportedLanguages = [
    { id: Intl.da_DK, label: "Danish" },
    { id: Intl.en_US, label: "English" },
    { id: Intl.de_DE, label: "German" },
];
